import script from "./StockImages.vue?vue&type=script&setup=true&lang=js"
export * from "./StockImages.vue?vue&type=script&setup=true&lang=js"

import "./StockImages.vue?vue&type=style&index=0&id=bc562ff6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc562ff6"]])

export default __exports__